var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0.5V10.5H12.388V2.45756L10 3.28576V1.92368L13.806 0.5H14Z",
    fill: "#818EA1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6632 4.67582V6.04258H1.30909V4.67582H6.6632ZM1.73853 0.5V10.5H0V0.5H1.73853ZM8 0.5V10.5H6.2684V0.5H8Z",
    fill: "#818EA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.2c89f05ae75f74d228f39420feee5711.svg";
export { ForwardRef as ReactComponent };